import React from 'react';
import { CircleToBlockLoading } from 'react-loadingg';
const Container = () => <CircleToBlockLoading />;
export default Container;